export const actions = {
    async getProductLabels({ commit, dispatch, rootState }, { sku, mode = 'PRODUCT', productId = null }) {
        try {
            return await this.$axios.$get('/getProductAmLabel?', {
                params: { sku, mode, productId },
            })
        } catch (e) {
            console.error(e.message);
            return [];
        }
    },
}
